'use strict';

require('./FormGroupDropdownCustom.scss');

const React = require('react'),
    PropTypes = React.PropTypes,
    DropDown = require('components/Commons/DropDown/DropDown'),
    ContentUtils = require('utils/ContentUtils'),
    {findIndex} = require('lodash/array'),
    Constants = require('constants/AppConstants'),
    set = require('lodash/object').set,
    get = require('lodash/object').get,
    BasicFormGroup = require('../BasicFormGroup');

const DEFAULT_READER_ATTRIBUTE = 'text';

const FormGroupDropdownCustom = React.createClass({displayName: "FormGroupDropdownCustom",

    propTypes: Object.assign({}, BasicFormGroup.propTypes, {
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        outputMapper: PropTypes.object,
        isImmutable: PropTypes.bool,
        isEditMode: PropTypes.bool,
        onEnter: PropTypes.func,
        name: PropTypes.string,
        floatingLabelText: PropTypes.string,
        wrapperMenuItem: PropTypes.func,
        idAttribute: PropTypes.any,

        // Input fields ------------------------

        /**
         * The list of items which will be used to generate the MenuItem
         */
        items: PropTypes.array.isRequired,

        /**
         * This attribute are several proposes. For instance:
         * As a `displayName` of given Menu item list ({@link items}).
         * Also is used this attribute to read each menu item of Dropdown attribute, when
         * need to know which menu item are selected.
         */
        readerAttribute: PropTypes.string,

        /**
         * This attribute will be use against to {@link value} props to retrieve the
         * information needed from outside selected value. Will be use to match outer
         * value which internal menu item.
         */
        readerAttributeValue: PropTypes.string,

        // Output field ------------------------

        /**
         * This is attribute will use to write the name of the attribute when submit the form.
         * (Optionally) When it doesn't defined we will use by default {@link readerAttribute}
         */
        writerAttribute: PropTypes.string,

        /**
         * This attribute allow us to specify the field will take at the moment
         * to write the value of selected item.
         */
        customReaderWriterAttribute: PropTypes.string,

        /**
         * Is the value which are selected from outside of menu item. So we need to use
         * {@link readerAttributeValue} in order to know which MenuItem
         * are related to this outer `value`, specially when need to know which index of menu item
         * are need to be selected.
         */
        value: PropTypes.string
    }),

    getInitialState() {
        return {
            selectedMenuItemIndex: -1,
            selectedMenuItem: null
        };
    },

    componentDidMount() {
        const {operationsHolder} = this.props;
        // React will throw a warning for bind the context with each operation, but we need it, otherwise
        // we don't have access to the context of the component when need to perform each operation.
        operationsHolder.addValidator(this.isValid.bind(this));
        operationsHolder.addCleaner(this.clean.bind(this));
        operationsHolder.addItemProvider(this.getValue.bind(this));
    },

    clean() {
        this.setState({
            selectedMenuItemIndex: -1,
            selectedMenuItem: null,
            isFocus: false
        });
    },

    getValue() {
        const {
            writerAttribute,
            outputMapper,
            readerAttribute,
            customReaderWriterAttribute,
            value,
            idAttribute,
            items
        } = this.props;

        const isEditMode = ContentUtils.isNotNullOrUndefined(value);

        let selectedMenuItemIndex = this.state.selectedMenuItemIndex;
        if (isEditMode && selectedMenuItemIndex === -1) {
            selectedMenuItemIndex = getIndexValue(items, value, idAttribute || 'id');
        }

        const currentValue = this._getSelectedMenuItemValue(
            readerAttribute,
            customReaderWriterAttribute,
            selectedMenuItemIndex
        );

        let wrapper = {};
        let safeWriterAttribute = writerAttribute || readerAttribute; // make writer attribute optionally

        if (outputMapper) {
            const keyOutput = outputMapper[currentValue];
            wrapper = set(wrapper, safeWriterAttribute, keyOutput);
        } else {
            wrapper = set(wrapper, safeWriterAttribute, currentValue);
        }

        return wrapper;
    },

    _onBlur(callback, selectedItem) {
        if (this.refs && this.refs.dropdownEl) {
            const haveItemSelected = !!selectedItem;
            const haveItemsDefined = ContentUtils.isNotEmptyArray(
                this.props.items
            );

            if (haveItemSelected && haveItemsDefined) {
                const itemSelectedIndex = get(selectedItem, 'payload');

                this.setState(
                    {
                        selectedItem,
                        selectedMenuItemIndex: itemSelectedIndex,
                        isFocus: false
                    },
                    () => {
                        if (callback) {
                            callback();
                        }
                    }
                );
            }
        } else {
            if (callback) {
                callback();
            }
        }
    },

    _getIndexOfMenuItem(textTarget) {
        const isMenuItemObject = typeof this.props.items[0] === 'object';
        const isMenuItemNumber = typeof this.props.items[0] === 'number';
        let menuItemTexts;

        if (isMenuItemObject) {
            menuItemTexts = this.props.items.map(item =>
                get(item, 'name', get(item, 'description'))
            );
        } else if (isMenuItemNumber) {
            menuItemTexts = this.props.items;
            return menuItemTexts.indexOf(+textTarget) + 1;
        } else {
            menuItemTexts = this.props.items;
        }

        if (menuItemTexts) {
            return menuItemTexts.indexOf(textTarget) + 1;
        }
    },

    isValid() {
        let {
            name,
            additionalValidation,
            additionalValidationFieldName,
            isRequired,
            isRelaxedText,
            readerAttribute,
            onBlur,
            items,
            value,
            idAttribute
        } = this.props;
        let messageError = '';
        let selectedMenuItemValue;



        if (ContentUtils.isNull(isRequired)) {
            isRequired = true;
        }

        if (!isRequired) {
            this.setState({messageError: ''});
            return messageError === '';
        }

        const isEditMode = ContentUtils.isNotNullOrUndefined(value);
        const isNewMode = isEditMode === false;
        const isNonItemselected = this.state.selectedMenuItemIndex === -1;

        let selectedMenuItemIndex = this.state.selectedMenuItemIndex;
        if (isEditMode && selectedMenuItemIndex === -1) {
            selectedMenuItemIndex = getIndexValue(items, value, idAttribute);
        }

        if (selectedMenuItemIndex > -1) {
            selectedMenuItemValue = this._getSelectedMenuItemValue(
                readerAttribute,
                readerAttribute,
                selectedMenuItemIndex
            );
            messageError = this._checkSelectedMenuItemValue(
                isRelaxedText,
                selectedMenuItemValue
            );
        } else if (isEditMode) {
            messageError = ContentUtils.isValidText(null, name);
        }

        if (additionalValidationFieldName) {
            const itemSelected = get(
                items,
                `${this.state.selectedMenuItemIndex - 1}`
            );
            const attributeValue = get(
                itemSelected,
                additionalValidationFieldName
            );
            if (!messageError && additionalValidation) {
                messageError = additionalValidation(attributeValue);
            }
        } else {
            if (!messageError && additionalValidation) {
                messageError = additionalValidation(selectedMenuItemValue);
            }
        }

        if (isNewMode && isNonItemselected) {
            messageError = `${name} ${t('notification_is_required')}`;
        }

        this.setState({messageError: messageError}, () => {
            if (onBlur) {
                onBlur();
            }
        });
        return messageError === '';
    },

    _getSelectedMenuItemValue(readerAttribute, customReaderWriterAttribute, selectedMenuItemIndex) {
        let index = selectedMenuItemIndex - 1;

        if (index < 0) {
            index = this.state.selectedMenuItemIndex - 1;
        }
        const itemValue = this.props.items[index];
        let itemModel;

        if (ContentUtils.isStringOrIntegerItem(itemValue)) {
            itemModel = get(this.state, 'selectedMenuItem.itemModel');
        } else {
            const attribute =
                customReaderWriterAttribute || readerAttribute || 'text';
            itemModel = get(itemValue, attribute);
        }

        if (ContentUtils.isStringOrIntegerItem(itemModel)) {
            // enter here means that current MenuItem is just simple text or number
            // which means that item model are the value it self
            return itemModel;
        } else {
            return get(
                itemModel,
                customReaderWriterAttribute || readerAttribute || 'text'
            );
        }
    },

    _onChange(selectedMenuItem, evt) {
        const {onChange} = this.props;
        this.setState({
            selectedMenuItem,
            selectedMenuItemIndex: selectedMenuItem.payload
        });

        if (onChange) {
            onChange(evt, get(selectedMenuItem, 'index'), selectedMenuItem);
        }
    },

    _checkSelectedMenuItemValue(isRelaxedText, selectedMenuItemValue) {
        return isRelaxedText
            ? ContentUtils.isValidTextNotRequiredWithCustomValidation(
                selectedMenuItemValue,
                name,
                Constants.REGEX_NAME_RELAXED
            )
            : ContentUtils.isValidText(selectedMenuItemValue, name);
    },

    _setFocus() {
        this.setState({
            isFocus: true
        });
    },

    render() {
        const {
            floatingLabelText,
            isDisabled,
            items,
            isImmutable,
            isEditMode,
            onEnter,
            name,
            readerAttribute,
            value,
            wrapperMenuItem,
            idAttribute
        } = this.props;
        const {isFocus, selectedMenuItemIndex} = this.state;


        let dropdownClassName = 'form-group form-group-dropdown-custom';

        if (isFocus) {
            dropdownClassName += ' is-active';
        }

        const isDisabledInput = !!isDisabled || (isImmutable && isEditMode);

        dropdownClassName += isDisabledInput ? ' is-disabled' : '';

        const currentSelectedIndex = selectedMenuItemIndex > -1
            ? selectedMenuItemIndex
            : getIndexValue(items, value, idAttribute || 'id');

        return (
            React.createElement("div", {className: dropdownClassName}, 
                React.createElement(DropDown, {
                    className: `form-group-dropdown-input`, 
                    ref: "dropdownEl", 
                    readerAttribute: 
                        readerAttribute || DEFAULT_READER_ATTRIBUTE, 
                    
                    wrapperMenuItem: wrapperMenuItem, 
                    floatingLabelText: floatingLabelText, 
                    labelStyle: {color: '#fff', fontWeight: '300'}, 
                    onChange: this._onChange, 
                    onEnterKeyDown: onEnter, 
                    name: name, 
                    onBlur: this._onBlur.bind(this, this.isValid), 
                    onFocus: this._setFocus, 
                    floatingLabelStyle: {
                        color: '#fff !important',
                        fontWeight: '300'
                    }, 
                    items: items, 
                    selectedIndex: currentSelectedIndex, 
                    style: {width: '100%'}, 
                    errorText: get(this.state, 'messageError', ''), 
                    disabled: isDisabledInput}
                )
            )
        );
    }
});

function getIndexValue(items, value, idAttribute) {
    return (
        findIndex(
            items,
            item => get(item, idAttribute) === get(value, idAttribute)
        ) + 1
    ); // transform to payload index
}

module.exports = FormGroupDropdownCustom;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/BasicForm/FormGroupDropdown/FormGroupDropdownCustom.jsx
 **/